import { Divider } from '../../Divider'
import {
  EntityPhaseList,
  EntityPhaseLoading,
  EntityProfileHeader,
  EntityProfileHeaderAddNewButton,
  EntityProfileHeaderInfoItems,
  EntityProfileHeaderLabelList,
  EntityProfileHeaderMoreButton,
} from '../../Entity'
import {
  getRequestPhaseStatusText,
  getTooltipAdditionalText,
} from '../../Request'
import { Container } from '../Container'

import {
  INFO_ITEM_TITLES,
  InfoItemsFields,
  PROFILE_DATA_MOCK,
} from './ProfileHeader.constants'
import {
  EditTitleField,
  getValidationSchemaTitle,
  renderInfoItem,
} from './ProfileHeader.utils'

import * as styles from './ProfileHeader.module.css'

import ServiceRequestIcon from '../../../icons/service-request.svg'

function Content({ isLoading }) {
  return (
    <>
      {isLoading ? (
        <EntityPhaseLoading />
      ) : (
        <>
          <EntityPhaseList
            className={styles.phases}
            getPhaseStatusText={getRequestPhaseStatusText}
            getTooltipAdditionalText={getTooltipAdditionalText}
            items={[
              { id: 0, name: 'First phase', progress: 100 },
              { id: 1, name: 'Second phase', progress: 50 },
              { id: 2, name: 'Third phase', progress: 0 },
              { id: 3, name: 'Fourth phase', progress: 0 },
              { id: 4, name: 'Fifth phase', progress: 0 },
            ]}
          />
          <Divider className={styles.divider} />
          <EntityProfileHeaderLabelList
            items={[
              {
                backgroundColor: '#E8B14A',
                id: 0,
                text: 'Label 1 Label 1 Label 1 Label 1 Label 1 Label 1 Label 1 Label 1',
              },
              { backgroundColor: '#9B5BF1', id: 1, text: 'Label 2' },
              { backgroundColor: '#A0B95C', id: 2, text: 'Label 3' },
              { backgroundColor: '#ADA5B7', id: 3, text: 'Label 4' },
              { backgroundColor: '#71AECD', id: 4, text: 'Label 5' },
            ]}
          />
        </>
      )}
    </>
  )
}

function Actions() {
  return (
    <>
      <EntityProfileHeaderAddNewButton />
      <EntityProfileHeaderMoreButton />
    </>
  )
}

function InfoItems({ isLoading, ...restProps }) {
  return (
    <EntityProfileHeaderInfoItems
      {...restProps}
      isLoading={isLoading}
      renderItem={renderInfoItem}
    />
  )
}

function ProfileHeader() {
  const preparedHeaderInfoItems = Object.values(InfoItemsFields).map(item => ({
    canEdit: true,
    name: item,
    title: INFO_ITEM_TITLES[item],
    value: PROFILE_DATA_MOCK[item],
  }))

  return (
    <>
      <Container label='ProfileHeader'>
        <EntityProfileHeader
          Content={Content}
          InfoItems={InfoItems}
          editModalProps={{
            Fields: EditTitleField,
            validationSchema: getValidationSchemaTitle,
          }}
          footerProps={{
            Actions: Actions,
          }}
          headerProps={{
            entityAvatarProps: { Icon: ServiceRequestIcon },
            text: 'title titlet title title title title title title title title title title titletitle title title title titletitle title',
          }}
          infoItemsProps={{ items: preparedHeaderInfoItems }}
        />
      </Container>
      <Container label='ProfileHeader, loading'>
        <EntityProfileHeader
          isLoading
          Content={Content}
          InfoItems={InfoItems}
          Phases={null}
          footerProps={{
            Actions: Actions,
          }}
          headerProps={{
            entityAvatarProps: { Icon: ServiceRequestIcon },
            text: 'title titlet title title title title title title title title title title titletitle title title title titletitle title',
          }}
        />
      </Container>
      <Container label='ProfileHeader without title'>
        <EntityProfileHeader
          InfoItems={InfoItems}
          Phases={null}
          footerProps={{
            Actions: Actions,
          }}
          headerProps={{
            entityAvatarProps: { Icon: ServiceRequestIcon },
            textPlaceholder: 'No service request',
          }}
          infoItemsProps={{ items: preparedHeaderInfoItems }}
        />
      </Container>
    </>
  )
}

export default ProfileHeader
